<a
  class="mobile-menu-item"
  fxLayoutAlign="flex-start center"
  (click)="onItemClick()"
  appDisableClickEvent
>
  {{ linkText }}
  <mm-icon name="chevron-right" class="mobile-menu-item__arrow"> </mm-icon>
</a>
